import { EXCEL_FILE_EXTENSION } from "@app/shared/constants/constants";
import { quarterlyFeedback } from "@app/shared/constants/global.enum";

export interface FileValidationResult {
  isValid: boolean;
  errorMessage: string;
  fileSize?: string;
}

/**
 * Validates a file for type and size restrictions
 * @param file The file to validate
 * @param maxSizeMB Maximum file size in MB
 * @returns Validation result with error message if invalid
 */
export function validateFile(file: File, maxSizeMB: number = 3): FileValidationResult {
  // Check file type
  if (!EXCEL_FILE_EXTENSION.some(type => file.type === type)) {
    return {
      isValid: false,
      errorMessage: quarterlyFeedback.invalidType
    };
  }

  // Check file size
  const fileSizeInMB = file.size / (1024 * 1024);
  if (fileSizeInMB > maxSizeMB) {
    return {
      isValid: false,
      errorMessage: quarterlyFeedback.fileExceedsSize,
      fileSize: `${Math.floor(fileSizeInMB)} MB`
    };
  }

  // Return file size for information purposes
  let fileSize = '';
  if (file.size > 1024) {
    fileSize = `${Math.floor(file.size / 1024)} KB`;
  }

  return {
    isValid: true,
    errorMessage: '',
    fileSize
  };
}
